(function(){
  'use strict';

  angular
    .module('AcaApp')
    .directive('checkList', directive);

  function directive(){
    var dir = {
      templateUrl: './app/views/send/partials/check-list.html',
      controller: Controller,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        sendPage: '=',
        generateTransmittal: '&',
        back: '&',
        goto: '&'
      }
    };

    return dir;
  }

  Controller.$inject = ['CheckListService', '$location'];

  function Controller(checkListService, $location){
    var _this = this;

    /** properties */
    _this.employers = [];
    _this.transmittals = [];
    _this.irsErrors = [];
    _this.rejections = false;
    _this.corrections1095 = [];
    _this.corrections1094c = [];

    /** show/hide toggleable boxes */
    _this.showEmployers = true;
    _this.showTransmittals = true;
    _this.showIrsErrors = true;
    _this.showRejections = true;
    _this.showCorrections1095 = true;
    _this.showCorrections1094c = true;

    /** methods */
    _this.viewEmployers = _viewEmployers;
    _this.markComplete = _markComplete;
    _this.sendTransmittals = _sendTransmittals;
    _this.goIrsErrors = _goIrsErrors;
    _this.goSendCorrection = _goSendCorrection;

    /** Look for data in server at controller initialize. */
    _activate();

    /** @private */
    function _activate(){
      checkListService.getData(_getData, _setShowProperties);
    }

    /** @private */
    function _getData(data){
      _this.employers = data.employers;
      _this.transmittals = data.transmittals;
      _this.irsErrors = data.irsErrors;
      _this.rejections = data.rejections;
      _this.corrections1095 = data.corrections1095;
      _this.corrections1094c = data.corrections1094c;
    }

    /** @private */
    function _setShowProperties(data){
      _this.showEmployers = !!data.employers.length;
      _this.showTransmittals = !!data.transmittals.length;
      _this.showIrsErrors = data.irsErrors === 'UNREVIEWED';
      _this.showRejections = data.rejections;
      _this.showCorrections1095 = !!data.corrections1095.length;
      _this.showCorrections1094c = !!data.corrections1094c.length;
    }

    /** @public */
    function _viewEmployers(){
      $location
        .path('records')
        .search({section: 'recordEmployer'});
    }

    /** @public */
    function _markComplete(){
      checkListService.markAsCompleted().then(function(data){
        _this.showEmployers = !data;
      });
    }

    /** @public */
    function _sendTransmittals(){
      _this.generateTransmittal();
    }

    /** @public */
    function _goIrsErrors(){
      $location
        .path('corrections');
    }

    /** @public */
    function _goSendCorrection(){
      $location
        .path('corrections')
        .search({section: 'retransmit-corrected'});
    }
  }
})();
